var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeliveryIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.705,
    height: 16.189,
    viewBox: "0 0 14.705 16.189",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13297",
    "data-name": "Group 13297",
    transform: "translate(-2.312 -1.33)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_632",
    "data-name": "Line 632",
    x1: 6.664,
    y1: 3.843,
    transform: "translate(6.332 3.637)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24193",
    "data-name": "Path 24193",
    d: "M16.328,12.367V6.443a1.481,1.481,0,0,0-.74-1.281L10.4,2.2a1.481,1.481,0,0,0-1.481,0L3.74,5.162A1.481,1.481,0,0,0,3,6.443v5.924a1.481,1.481,0,0,0,.74,1.281L8.924,16.61a1.481,1.481,0,0,0,1.481,0l5.183-2.962A1.481,1.481,0,0,0,16.328,12.367Z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24194",
    "data-name": "Path 24194",
    d: "M3.27,6.96,9.734,10.7,16.2,6.96",
    transform: "translate(-0.07 -1.287)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_633",
    "data-name": "Line 633",
    y1: 7.464,
    transform: "translate(9.664 9.405)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryIcon);
export default __webpack_public_path__ + "static/media/delivery-icon.8734d7996ece3332b13d06606c0f51d8.svg";
export { ForwardRef as ReactComponent };